import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-tab2',
  templateUrl: 'tab2.page.html',
  styleUrls: ['tab2.page.scss']
})
export class Tab2Page {
  public parking: Object;
  public parking_total: number;
  public marker_color: string;
  public parkings: Object;
  public alert_status: Boolean;
  public alert_message: String;

  constructor( private http: HttpClient ) {}

  ngOnInit() {
    this.parking = {};
    this.parkings = {};
    this.alert_status = false;
    this.alert_message = "";
    this.http.get("https://api.infoparkingamalfi.com/parking/status/").subscribe( data => {
      this.parking = data;
      this.parkings = {
        0: {
          "parking": this.parking[0].total_spot-this.parking[0].busy_spot,
          "parking_total": this.parking[0].total_spot,
          "marker_color": this.parking[0].color,
          "hide": false
        },
        1: {
          "parking": this.parking[1].total_spot-this.parking[1].busy_spot,
          "parking_total": this.parking[1].total_spot,
          "marker_color": this.parking[1].color,
          "hide": false
        }, 
        2:{
          "parking": this.parking[2].total_spot-this.parking[2].busy_spot,
          "parking_total": this.parking[2].total_spot,
          "marker_color": this.parking[2].color,
          "hide": false
        },
        3: {
          "parking": this.parking[3].total_spot-this.parking[3].busy_spot,
          "parking_total": this.parking[3].total_spot,
          "marker_color": this.parking[3].color,
          "hide": false
        }
      };
    });
    this.http.get("https://api.infoparkingamalfi.com/parking/status/alert").subscribe( data_alert => {
      this.alert_status = data_alert[0].status;
      this.alert_message = data_alert[0].message;
    });

    let timer = setInterval(()=> {
      this.refreshParkings();
      clearInterval(timer)
    }, 10000);

  }

  doRefresh(event) {
    setTimeout(() => {
      this.ngOnInit();
      event.target.complete();
    }, 2000);
  }

  ionViewWillEnter(){
    this.ngOnInit();
  }

  refreshParkings(){
    this.http.get("https://api.infoparkingamalfi.com/parking/status/").subscribe( data => {
      this.parking = data;
      this.parkings = {
        0: {
          "parking": this.parking[0].total_spot-this.parking[0].busy_spot,
          "parking_total": this.parking[0].total_spot,
          "marker_color": this.parking[0].color
        },
        1: {
          "parking": this.parking[1].total_spot-this.parking[1].busy_spot,
          "parking_total": this.parking[1].total_spot,
          "marker_color": this.parking[1].color
        }, 
        2:{
          "parking": this.parking[2].total_spot-this.parking[2].busy_spot,
          "parking_total": this.parking[2].total_spot,
          "marker_color": this.parking[2].color
        },
        3: {
          "parking": this.parking[3].total_spot-this.parking[3].busy_spot,
          "parking_total": this.parking[3].total_spot,
          "marker_color": this.parking[3].color
        }
      };
    });
    let timer = setInterval(()=> {
      this.refreshParkings();
      clearInterval(timer)
    }, 10000);
  }

}
